<template>
  <div>
    <h4>自然科</h4>
    <dl>
      <dt>菁英自然班</dt>
      <dd>
        菁英班適合公、私立各校學生培養自然科實力與判斷力，加入動手操作自然科學實驗，生動有趣的自然課堂，讓你好記憶、好吸收！
      </dd>

      <dt>拔尖自然班 （需經甄試入班）</dt>
      <dd>
        拔尖班適合資質優異學生，穩紮穩打的自然科訓練及實驗操作，以及學習更深入、更超前的內容，是未來考慮報考高中科學班、數資班等特殊班同學不可不參加的課程！
      </dd>

      <dt>衛道自然專班</dt>
      <dd>
        衛道國中與其他公、私校不同，在國一就同時上生物、理化課程，針對衛道進度特別開設衛道自然專班。
      </dd>

      <dt>曉明、明道自然專班</dt>
      <dd>
        國二、國三理化課程在各校不同進度下開設曉明、明道專班，專門針對各私校進度。
      </dd>
    </dl>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
